// 初始化的js
import '@/global/init'

// 这里是配置全局项目的内容
import Vue from 'vue'
import '@/global/directive'

import '@/common/sass/reset.scss'

import util from '@/common/libs/util'

Object.defineProperty(Vue.prototype, '$util', {
  value: util
})

// 引入字体图标
import '@/../static_seeker/font/iconfont.css'
import '@/../static_seeker/font/iconfont2.css'

//引入公共的elementUI组件
import 'element-ui/lib/theme-chalk/index.css'

import {
  Alert,
  Message,
  Loading,
  Button,
  Input,
  Icon,
  Container,
  Dialog,
  Header,
  Main,
  Footer,
  Aside,
  Row,
  Col,
  Form,
  FormItem,
  Popover,
  Image,
  MessageBox,
  Checkbox,
  Link,
  Carousel
}
from 'element-ui'

Vue.use(Alert)
Vue.use(Button)
Vue.use(Input)
Vue.use(Loading)
Vue.use(Icon)

Vue.use(Container)
Vue.use(Header)
Vue.use(Main)
Vue.use(Footer)
Vue.use(Aside)

Vue.use(Row)
Vue.use(Col)

// Footer需要
Vue.use(Image)
Vue.use(Link)


Vue.use(Carousel)

// 登录需要
Vue.use(Form)
Vue.use(FormItem)

// 底部导航需要
Vue.use(Popover)
Vue.use(Checkbox)
Vue.use(Dialog)

Object.defineProperty(Vue.prototype, '$message', {
  value: Message
})

Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Date.prototype.format = function(fmt) {
  var o = {
    'y+': this.getFullYear(),
    'M+': this.getMonth() + 1,
    'd+': this.getDate(),
    'h+': this.getHours(),
    'm+': this.getMinutes(),
    's+': this.getSeconds(),
    'q+': Math.floor((this.getMonth() + 3) / 3),
    'S': this.getMilliseconds()
  };

  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ?
        o[k] < 10 ?
        '0' + o[k] :
        o[k] :
        ('00' + o[k]).substr(('' + o[k]).length)
      );
  }
  return fmt;
};

// 配置全局组件
// import FooterBox from '@/components/Footer/FooterQrcode'
import SliderFooter from '@/components/Footer/SliderFooter'
import BaseLogin from '@/components/Login/Login'
import HeaderNav from '@/components/Header/HeaderNav'
import NoData from '@/components/NoData'
import NoLogin from '@/components/NoLogin'
import SideBar from '@/components/SideBar/SideBar'
import ListBottom from '@/components/List/Bottom'
import globalCompanyName from '@/components/RealName/realname-company-name.vue'

Vue.component('globalCompanyName', globalCompanyName)

Vue.component('footer-box', SliderFooter)
Vue.component('base-login', BaseLogin)
Vue.component('header-nav', HeaderNav)
Vue.component('no-data', NoData)
Vue.component('no-login', NoLogin)
Vue.component('side-bar', SideBar)
Vue.component('list-bottom', ListBottom)

Vue.config.productionTip = false

Vue.directive('real-img', function (el, binding) {
  let imgURL = binding.value //获取图片地址
  let defaultURL = el.getAttribute('default-img') //获取默认图片地址
  if (imgURL) {
    var obj = {"img": imgURL}
    util.tansPics(obj, "img");

    imgURL = obj.img;

    var a = function (url, callback) {
      var img = new Image()
      img.onload = function () {
        if (this.complete === true) {
          typeof callback === 'function' ? callback(true) : null
          img = null
        }
      }
      img.onerror = function () {
        typeof callback === 'function' ? callback(false) : null
        img = null
      }
      img.src = url
    }
    a(imgURL, function (exist) {
      if (exist) {
        el.setAttribute('src', imgURL)
      } else {
        if (defaultURL) {
          el.setAttribute('src', defaultURL)
        }
      }
    })
  } else if (defaultURL) {
    el.setAttribute('src', defaultURL)
  }
})

//时间比较
function times(time1){
  var now = new Date()    //当前时间
  var end = new Date(time1.replace(/-/g, '/')) //到期时间
  var nowTime = end.getTime()-now.getTime()
  if(nowTime>0){
    return true;
  }else{
    return false;
  }
}

//未超过此时间时，执行下面的代码
if(times('2022-12-03 16:00:00')){

  var html = document.getElementsByTagName("html")[0].style;

  html['-webkit-filter']="grayscale(100%)";
  html['-moz-filter']="grayscale(100%)";
  html['-ms-filter']="grayscale(100%)";
  html['-o-filter']="grayscale(100%)";
  html['filter']="grayscale(100%)";
  html['filter']="progid:DXImageTransform.Microsoft.BasicImage(grayscale=1)";
}




// WEBPACK FOOTER //
// ./src/global/index.js